import { themeStyle } from '@src/theming';
import styled from 'styled-components';

export const Wrapper = styled.span`
  svg {
    .kittl {
      fill: ${themeStyle.varInkMain};
    }
  }
`;
